import React, { useMemo } from 'react';
import { GitCompare, CheckCircle, XCircle, FileText, Star } from 'lucide-react';
import ApprobationsCrudShell from './ApprobationsCrudShell';
import {
  ENTITY_TYPES, WORKFLOW_STATUS, statusBadge, entityLabel, defaultStats,
  mapRecordJsonFields, normalizeStatusValue,
} from './approbationsShared';

const NS = 'workflowsActifsPage';
const API = '/api/approbations/workflows';

const EMPTY = {
  workflow_code: '', name: '', description: '', entity_type: '', status: 'actif',
  priority: '0', is_default: false, chain_json: '[]', notes: '',
};

export default function WorkflowsActifsPage() {
  const entityOpts = useMemo(() => ENTITY_TYPES.map((e) => ({ value: e.value, labelKey: e.labelKey })), []);
  const statusOpts = useMemo(() => WORKFLOW_STATUS.map((s) => ({ value: s.value, labelKey: s.labelKey })), []);

  return (
    <ApprobationsCrudShell
      ns={NS}
      icon={GitCompare}
      apiPath={API}
      codeField="workflow_code"
      entityPrefixKey="approvalWorkflow"
      codePrefixFallback="WF"
      gradient="from-cyan-500 to-cyan-700"
      entityLabel="مسار الاعتماد"
      entityLabelPlural="مسارات الاعتماد"
      emptyForm={EMPTY}
      mapRecordToForm={(r) => mapRecordJsonFields(r, EMPTY)}
      filterRecords={(r) => normalizeStatusValue(r.status) === 'actif'}
      computeStats={(records) => defaultStats(records, {
        totalIcon: GitCompare,
        fields: [
          { titleKey: 'stat_active', field: 'status', value: 'actif', icon: CheckCircle, color: 'from-green-500 to-green-600' },
          { titleKey: 'stat_inactive', field: 'status', value: 'inactif', icon: XCircle, color: 'from-red-500 to-red-600' },
          { titleKey: 'stat_draft', field: 'status', value: 'brouillon', icon: FileText, color: 'from-amber-500 to-amber-600' },
          { titleKey: 'stat_default', field: 'is_default', value: 1, icon: Star, color: 'from-purple-500 to-purple-600' },
        ],
      })}
      columns={[
        { key: 'workflow_code', labelKey: 'col_code' },
        { key: 'name', labelKey: 'col_name' },
        { key: 'entity_type', labelKey: 'col_entity', render: (r, _p, _t, pl) => entityLabel(r.entity_type, pl) },
        { key: 'priority', labelKey: 'col_priority' },
        { key: 'status', labelKey: 'col_status', render: (r, _p, _t, pl) => statusBadge(r.status, pl) },
        { key: 'created_at', labelKey: 'col_created' },
      ]}
      formSections={[
        {
          id: 'identity',
          titleKey: 'section_identity',
          fields: [
            { key: 'name', labelKey: 'field_name', required: true },
            { key: 'entity_type', labelKey: 'field_entity_type', type: 'select', options: entityOpts },
            { key: 'status', labelKey: 'field_status', type: 'select', options: statusOpts },
            { key: 'priority', labelKey: 'field_priority', type: 'number' },
            { key: 'description', labelKey: 'field_description', type: 'textarea', fullWidth: true },
          ],
        },
        {
          id: 'chain',
          titleKey: 'section_chain',
          fields: [
            { key: 'chain_json', labelKey: 'field_chain_json', type: 'chain_steps', fullWidth: true },
            { key: 'notes', labelKey: 'field_notes', type: 'textarea' },
          ],
        },
      ]}
      mapFormToPayload={(f) => ({
        workflow_code: f.workflow_code,
        name: f.name,
        description: f.description || null,
        entity_type: f.entity_type || null,
        status: f.status || 'actif',
        priority: f.priority !== '' ? parseInt(f.priority, 10) : 0,
        is_default: f.is_default ? 1 : 0,
        chain_json: f.chain_json || null,
        notes: f.notes || null,
      })}
    />
  );
}
